import { Box, Grid, Typography } from "@material-ui/core";
import PublishIcon from "@mui/icons-material/Publish";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const { green, yellow, red, stone, gray } = themeColorsDesingSystem;

const CARDS_CONFIG = [
  {
    key: "PUBLICADO",
    title: "Publicados",
    subtitle: "Ver todos",
    icon: PublishIcon,
    color: green.main,
    bg: `${green.main}22`,
  },
  {
    key: "RASCUNHO",
    title: "Rascunhos",
    subtitle: "Ver rascunhos",
    icon: EditNoteIcon,
    color: gray.main,
    bg: `${gray.main}22`,
  },
  {
    key: "AGENDADO",
    title: "Agendados",
    subtitle: "Ver agendados",
    icon: ScheduleIcon,
    color: yellow.main,
    bg: `${yellow.main}22`,
  },
  {
    key: "EXPIRADO",
    title: "Expirados",
    subtitle: "Ver expirados",
    icon: EventBusyIcon,
    color: red.main,
    bg: `${red.main}22`,
  },
];

export default function IndicatorCards({
  counts,
  activeStatus,
  onStatusClick,
}) {
  return (
    <Grid container spacing={2}>
      {CARDS_CONFIG.map((card) => {
        const Icon = card.icon;
        const isActive = activeStatus === card.key;

        return (
          <Grid item xs={12} sm={6} md={3} key={card.key}>
            <Box
              onClick={() => onStatusClick(isActive ? null : card.key)}
              style={{
                backgroundColor: themeColorsDesingSystem.background.main,
                borderRadius: 12,
                padding: "1.25rem",
                border: isActive
                  ? `2px solid ${card.color}`
                  : `1px solid ${stone.main}`,
                cursor: "pointer",
                transition: "box-shadow 0.2s",
                boxShadow: isActive ? `0 4px 12px ${card.bg}` : "none",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box>
                  <Typography
                    variant="body2"
                    style={{ color: gray.dark, marginBottom: 4 }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: themeColorsDesingSystem.text.primary,
                    }}
                  >
                    {counts[card.key] || 0}
                  </Typography>
                </Box>
                <Box
                  style={{
                    backgroundColor: card.bg,
                    borderRadius: 10,
                    padding: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon style={{ color: card.color, fontSize: 32 }} />
                </Box>
              </Box>
              <Typography
                variant="caption"
                style={{
                  color: card.color,
                  marginTop: 12,
                  display: "block",
                  fontWeight: 600,
                }}
              >
                {card.subtitle} →
              </Typography>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
